<script lang="ts">
	import '@andresot/tokens/scale';
	import '@andresot/tokens/colors';
	import '@andresot/tokens/typography';
	import '../styles.css';

	let { children } = $props();
</script>

<a class="skip-link" href="#main-content">Перейти к содержимому</a>
{@render children()}
